import {
  BoardCommonControllerService,
  BoardVo,
} from '@/__generated__/CommonApi';
import Bn from '@/assets/img/advocacy-for-children/city_bn@2x.png';
import Step01 from '@/assets/img/advocacy-for-children/city_step01.png';
import Step02 from '@/assets/img/advocacy-for-children/city_step02.png';
import Step03 from '@/assets/img/advocacy-for-children/city_step03.png';
import Step04 from '@/assets/img/advocacy-for-children/city_step04.png';
import Step05 from '@/assets/img/advocacy-for-children/city_step05.png';
import Step06 from '@/assets/img/advocacy-for-children/city_step06.png';
import Step07 from '@/assets/img/advocacy-for-children/city_step07.png';
import Step08 from '@/assets/img/advocacy-for-children/city_step08.png';
import StepArrow from '@/assets/img/advocacy-for-children/city_step_arrow.svg';
import Icon04 from '@/assets/img/advocacy-for-children/city_icon_04.png';
import Icon10 from '@/assets/img/advocacy-for-children/city_icon_10.png';
import Icon53 from '@/assets/img/advocacy-for-children/city_icon_53.png';
import Icon92 from '@/assets/img/advocacy-for-children/city_icon_92.png';
import Icon97 from '@/assets/img/advocacy-for-children/city_icon_97.png';
import Icon109 from '@/assets/img/advocacy-for-children/city_icon_109.png';
import Icon114 from '@/assets/img/advocacy-for-children/city_icon_114.png';
import Icon116 from '@/assets/img/advocacy-for-children/city_icon_116.png';
import Icon121 from '@/assets/img/advocacy-for-children/city_icon_121.png';
import Icon134 from '@/assets/img/advocacy-for-children/city_icon_134.png';
import Icon182 from '@/assets/img/advocacy-for-children/city_icon_182.png';
import CfciLogo from '@/assets/img/advocacy-for-children/cfci_logo@2x.png';
import CityBgCircle from '@/assets/img/advocacy-for-children/city_bg_circle.svg';
import Arrow from '@/assets/img/icons/icon_white_arrow_24x25@2x.png';
import { CampaignData } from '@/components/Card/CampaignCard';
import RelativeBoardCard from '@/components/Card/RelativeBoardCard';
import ContactUs from '@/components/ContactUs';
import Container from '@/components/Container';
import {
  NoList,
  DlBox,
} from '@/components/Css/PublicPrivatePartnership';
import Image from '@/components/Image';
import LinkSafe from '@/components/LinkSafe';
import PageComponent from '@/components/PageComponent';
import Section, { SectionNews } from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import { Tit } from '@/components/Titles';
import YoutubeSingle from '@/components/YoutubeSingle';
import { breakpoint } from '@/helpers/BreakpointHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import { PublicPrivateTab } from '@/page-blocks/advocacy-for-children/public-private-partnership';
import { PageProps } from 'gatsby';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

const assessmentData = [
  {
    id: 0,
    img: Icon134,
    no: `01`,
    tit: `정책 결정을 위한 근거 확보`,
    desc: `지방정부는 아동 관련 정책과 사업을 결정하기 위해 세분화된 현황조사를 실시하고 자료를 수집합니다. 정책 및 계획 수립을 위해서는 관련 데이터 수집, 관리, 분석을 포함하여 증거 기반의 의사결정을 위한 역량이 강화되어야 합니다.`,
  },
  {
    id: 1,
    img: Icon121,
    no: `02`,
    tit: `지속가능한 거버넌스 구축`,
    desc: `지방정부는 정책, 전략, 계획 등을 수립할 때 아동의 요구를 반영합니다. 또한 자원의 공평한 배분, 아동 관련 사업 수행을 위한 재원 마련, 도심 내 자원의 효과적인 활용을 지원해야 합니다.`,
  },
  {
    id: 2,
    img: Icon97,
    no: `03`,
    tit: `아동 참여 및 권리교육`,
    desc: `아동, 청소년, 보호자와 지역사회는 자신의 삶에 영향을 미치는 지방정부의 결정 사항에 대해 발언권을 가져야 합니다. 지방정부는 모든 아동, 청소년, 보호자 및 지역사회의 참여권을 보장하며, 차별, 불평등 및 빈곤 감소를 포함한 모든 문제를 효과적으로 해결하고, 투명하고 책임감 있는 의사결정 과정을 지원해야 합니다.`,
  },
  {
    id: 3,
    img: Icon109,
    no: `04`,
    tit: `행정서비스의 효과적 조정`,
    desc: `지방정부는 교육, 보건, 영양, 위생, 아동보호, 보육과 같은 사회서비스를 효율적, 효과적으로 조정해야 합니다. 부처간 협력을 통해 아동 및 보호자 대상 정책의 분절화를 방지하고 자원의 불필요한 낭비를 예방해야 합니다.`,
  },
  {
    id: 4,
    img: Icon53,
    no: `05`,
    tit: `아동친화 공간 조성`,
    desc: `아동을 위한 도시공간 계획을 통해 아동, 특히 빈곤층 아동에게 안전하고 지속가능한 생활 환경을 제공해야 합니다. 또한 아동이 주이용자인 시설과 공간을 조성할 때 아동의 의견을 반영해야 합니다.`,
  },
];

const childFriendlyData = [
  {
    id: 0,
    img: Icon10,
    no: `01`,
    tit: `놀이와 문화`,
    desc: `아동의 놀이 접근성(이동성), 신체·문화·예술 창작 활동, 놀이와 문화생활에 대한 전반적 만족, 놀이의 시간·비용적 여건, 또래 집단과의 상호작용, 놀 수 있는 공간의 보장`,
  },
  {
    id: 1,
    img: Icon92,
    no: `02`,
    tit: `참여와 존중`,
    desc: `아동권리 인식, 필요한 정보에 대한 접근성, 아동권리 및 참여 방법에 대한 교육과 학습, 아동참여 활동을 통한 긍정적 정서 경험, 의견 제안, 아동참여 기회, 타인에 대한 존중`,
  },
  {
    id: 2,
    img: Icon04,
    no: `03`,
    tit: `안전과 보호`,
    desc: `긴급 상황과 재난 시 보호, 교통사고 보호, 환경오염과 기후변화, 아동학대와 학교폭력, 유괴와 납치, 개인정보 침해, 사이버 괴롭힘과 부적절한 콘텐츠로부터 보호, 술·담배·마약과 같은 위험 물질로부터 보호`,
  },
  {
    id: 3,
    img: Icon182,
    no: `04`,
    tit: `보건과 복지`,
    desc: `아동의 균형 있는 영양 섭취, 건강관리 서비스, 보건의료 서비스, 경제적 취약계층 아동, 장애 아동, 가정 밖 아동 및 위기 아동, 학교 밖 아동의 사회적 보호체계`,
  },
  {
    id: 4,
    img: Icon114,
    no: `05`,
    tit: `교육환경`,
    desc: `소속 학교에 대한 전반적인 만족도, 학습전이(교육 효과성), 진로와 직업세계 교육, 바른 인성과 긍정적 사회관계 교육, 학습공간과 도서관, 학교와 학교 주변의 위생 및 안전, 학교와 학생 간의 소통`,
  },
  {
    id: 5,
    img: Icon116,
    no: `06`,
    tit: `가정환경`,
    desc: `가정의 편안함, 부모와의 고민거리 의논, 가족과 여가생활 및 대화, 주거지 안전, 가족 내 안정감`,
  },
];

const certifySteps = [
  [
    { img: Step01, label: `유니세프와\n업무 협약 체결` },
    { img: Step02, label: `아동친화도시 조성에 관한\n조례 제정 및 거버넌스 조성` },
    { img: Step03, label: `현황 조사 및 아동친화도시\n추진계획 수립` },
  ],
  [
    { img: Step04, label: `인증 심의` },
    { img: Step05, label: `아동친화도시\n최초인증` },
    { img: Step06, label: `사업 수행 및 모니터링,\n2년 단위의 표준조사 시행` },
  ],
  [
    { img: Step07, label: `인증 심의` },
    { img: Step08, label: `아동친화도시 인증갱신\n또는 상위단계 인증` },
  ],
];

const contactData = [
  {
    id: 1,
    tit: `문의`,
    costumer: `아동친화사회팀`,
    tel: `02-724-8561~6`,
    email: `cfc@unicef.or.kr`,
  },
];

const HowArticle = styled.article`
  padding-top: 32px;
  .dl-wrap {
    /* margin-bottom: 96px; */

    &:last-child {
      margin-bottom: 0;
    }

    & > dd {
      margin-top: 32px;
    }
  }

  figure {
    text-align: center;
    ${Image} {
      max-width: 1009px;
      display: inline-block;
    }
  }
  ${breakpoint(`tablet`)} {
    padding-top: 72px;
    .dl-wrap {
      margin-bottom: 72px;

      & > dd {
        margin-top: 48px;
      }
    }
  }
`;

const SectionCouncil = styled(Section)`
  ${SectionHeader} {
    padding-bottom: 172px;
  }
  .bn-wrap {
    display: block;
    background: #1cabe2;
    padding: 56px 40px;
    justify-content: space-between;
    position: relative;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
    }
    &::before {
      width: 192px;
      height: 192px;
      border-radius: 0 0 100% 0;
      left: 0;
      top: 0;
      background: #2589c9;
    }
    &::after {
      width: 25px;
      height: 43px;
      background: url(${Arrow}) center no-repeat;
      background-size: cover;
      right: 37px;
      top: 50%;
      transform: translate(0, -50%);
    }

    .col-dec {
      position: relative;
      z-index: 1;

      ${Tit} {
        display: block;
      }
    }
    .col-img {
      position: absolute;
      right: 105px;
      bottom: 0;
      width: 402px;
    }
  }
  ${breakpoint(1160)} {
    .bn-wrap {
      &::before {
        width: 16.55vw;
        height: 16.55vw;
      }

      .col-img {
        right: 9.05vw;
        max-width: 34.66vw;
      }
    }
  }
  ${breakpoint(`tablet`)} {
    ${SectionHeader} {
      padding-bottom: 72px;
    }
    .bn-wrap {
      padding: 18px 24px 0;

      &::after {
        width: 10px;
        height: 17px;
        right: 17px;
      }
      .col-img {
        position: relative;
        right: auto;
        margin: 0 -24px;
        max-width: initial;
        width: auto;
      }
    }
  }
`;

const AreaList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 32px 0 0;

  li {
    display: flex;
    align-items: flex-start;
    gap: 32px;
    padding: 32px 0;
    &:first-child {
      padding-top: 0;
    }

    .icon-wrap {
      flex-shrink: 0;
      width: 100px;

      ${Image} {
        width: 100px;
      }
    }

    .text-wrap {
      flex: 1;

      .area-no {
        display: inline;
        font-size: 20px;
        color: #1cabe2;
        font-weight: 700;
        margin-right: 8px;
      }

      .area-title {
        display: inline;
        margin-bottom: 12px;
      }

      .area-desc {
        font-size: 16px;
        line-height: 1.7;
        color: #666;
        word-break: keep-all;
      }
    }
  }

  ${breakpoint(`tablet`)} {
    li {
      gap: 20px;
      padding: 24px 0;

      .icon-wrap {
        width: 72px;

        ${Image} {
          width: 72px;
        }
      }

      .text-wrap {
        .area-desc {
          font-size: 14px;
        }
      }
    }
  }

  ${breakpoint(`mobile`)} {
    li {
      gap: 16px;
      padding: 20px 0;

      .icon-wrap {
        width: 56px;

        ${Image} {
          width: 56px;
        }
      }
    }
  }
`;

const AreaGroupTitle = styled.h4`
  margin: 96px 0 0;

  &:first-of-type {
    margin-top: 64px;
  }

  ${breakpoint(`tablet`)} {
    margin: 72px 0 0;

    &:first-of-type {
      margin-top: 48px;
    }
  }
`;

const CertifyFlow = styled.div`
  .certify-header {
    font-size: 48px;
    font-weight: 700;
    color: #1cabe2;
    text-align: center;
    line-height: 1.33;
    margin-bottom: 84px;
  }

  .certify-rows {
    display: flex;
    flex-direction: column;
    gap: 48px;
  }

  .certify-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2vw;
  }

  .certify-step {
    flex-shrink: 0;

    img {
      width: 27vw;
      max-width: 308px;
      height: auto;
      display: block;
    }
  }

  .certify-arrow {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 1.8vw;
      max-width: 20px;
      height: auto;
    }
  }

  ${breakpoint(`tablet`)} {
    .certify-header {
      font-size: 32px;
      margin-bottom: 48px;
    }

    .certify-rows {
      gap: 32px;
    }
  }

  ${breakpoint(`mobile`)} {
    .certify-header {
      font-size: 20px;
      margin-bottom: 24px;
    }

    .certify-rows {
      gap: 20px;
    }

    .certify-row {
      gap: 1.5vw;
    }
  }
`;

const SectionIntro = styled(Section)`
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    width: 421px;
    height: 421px;
    background: url(${CityBgCircle}) center no-repeat;
    background-size: contain;
    position: absolute;
    left: 82px;
    top: 11px;
    z-index: 0;
    pointer-events: none;
  }

  .intro-wrap {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
    gap: 10px;
  }

  .intro-header {
    width: 100%;
    padding-bottom: 0;
  }

  .logo-img {
    ${Image} {
      max-width: 1120px;
      display: block;
    }
  }

  .article-container {
    padding-top: 240px;

    & > article {
      margin-bottom: 140px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  ${breakpoint(1160)} {
    &::before {
      width: 21.93vw;
      height: 21.93vw;
      left: 4.27vw;
    }
  }

  ${breakpoint(`tablet`)} {
    &::before {
      width: 40vw;
      height: 40vw;
      left: -5vw;
      top: 0;
    }

    .article-container {
      padding-top: 120px;
      & > article {
        margin-bottom: 120px;
      }
    }
  }
`;

const ChildFriendlyCities: React.FC<PageProps> = ({ location }) => {
  const [news, setNews] = useState<CampaignData[]>([]);

  const loadNews = useCallback(async () => {
    try {
      const { data } = await BoardCommonControllerService.foListUsingGet({
        boardCategoryCode: ['280', '285', '290'],
        pagePerCount: 8,
        category: ['A024'],
      });
      const articles = data as any;
      setNews(
        articles
          .map((article: BoardVo) => ({
            id: article.boardIndexNumber,
            title: article.subject,
            pcImage: article.imgAttGrpNoTn,
            mobileImage: article.imgAttGrpNoTn,
            link: `/what-we-do/news/${article.boardIndexNumber}`,
            date: article.firstRegisterDate,
            boardCategoryCode: article.boardCategoryCode,
          }))
          .sort((a, b) => new Date(b.date) - new Date(a.date) || b.id - a.id),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    loadNews();
  }, [loadNews]);

  return (
    <LayoutWithTitle
      // 강제로 breadcrumb 고정
      location={{
        ...location,
        pathname: `/what-we-do/advocacy-for-children/public-private-partnership/child-friendly-cities`,
      }}
      paddingBtt
      title="아동친화사회 만들기"
      description="for every child, cities"
    >
      <PublicPrivateTab currentPath={location.pathname} />
      <Section className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1-5" color="sky" weight="normal">
                <PageComponent id="title1">
                  아동의 권리가 실현되는 지역사회 만들기,
                  <br className="small-hide" />
                  유니세프아동친화도시
                </PageComponent>
              </Tit>
            </h2>
            <p className="header-dec">
              <PageComponent id="content1">
                유니세프아동친화도시는 지방자치단체와의 강력한 파트너십을 통해
                지방자치단체 행정체계 내에서 유엔아동권리협약에 담긴 아동의
                권리를 온전히 실현하고 아동이 보다 나은 삶을 살 수 있도록
                아동에게 친화적인 환경을 가진 지역사회를 말합니다.
                유니세프아동친화도시는 유엔아동권리협약의 비차별원칙(제2조),
                아동 최상의 이익(제3조), 생존과 발달의 권리(제6조), 아동의견
                존중(제12조) 네 가지 일반 원칙을 기반으로 합니다.
              </PageComponent>
            </p>
          </SectionHeader>
          <PageComponent id="youtube1">
            <YoutubeSingle videoId="6WCWEXAw6qA" />
          </PageComponent>
        </Container>
      </Section>

      <SectionIntro className="by-sub-main-layout">
        <Container>
          <div className="intro-wrap">
            <SectionHeader className="intro-header">
              <h2>
                <Tit size="s1">
                  모든 아동이 행복한 지역사회 -
                  <br />
                  유니세프아동친화도시
                </Tit>
              </h2>
              <p className="header-dec">
                유니세프아동친화도시는 1996년 이스탄불에서 인류 거주 문제에 대한
                제2차 유엔 인간정주회의에서 시작되었습니다. 회의에 모인 각국
                대표는 '아동의 안녕(Well-being)'이야말로 건강한 도시, 민주적
                사회, 굿 거버넌스의 지표이며, 도시의 아동들이 보다 나은 삶을
                누릴 수 있도록 정부, 지방정부, 지역사회, NGO가 함께 노력해야
                한다는 유니세프의 제의를 결의안으로 채택하였습니다. 이것이
                유니세프아동친화도시의 탄생입니다. (유니세프 한국위원회, 2023)
              </p>
              <p className="header-dec">
                한국의 유니세프아동친화도시 이니셔티브는 2013년 11월 서울
                성북구를 첫번째 유니세프아동친화도시로 인증하면서 시작되었고,
                2026년 3월 현재 129개 지방자치단체와 함께 하고 있으며 그 중
                110개가 아동친화도시로 인증을 받았습니다.
              </p>
            </SectionHeader>
            <figure className="logo-img">
              <Image pcSrc={CfciLogo} mobileSrc={CfciLogo} />
            </figure>
          </div>

          <div className="article-container">
            <article>
              <h3>
                <Tit size="s1">아동친화도시 5대 목표</Tit>
              </h3>
              <p className="header-dec">
                아동친화도시 이니셔티브의 장기적인 목표는{` `}
                <strong>
                  '아동을 위한 지속가능한 변화와 노력으로 아동권리 증진을 위한
                  지역사회 이해관계자의 역량 강화'
                </strong>
                입니다. 즉, 아동친화도시는 유엔아동권리협약에 담긴 아동권리를
                실현하기 위해 아래 5가지 목표를 향해 지속적으로 변화하고
                발전하는 과정을 보여주어야 합니다.
              </p>
              <br />
              <br />
              <NoList>
                <li>
                  모든 아동은 지역사회와 공동체 안에서 그 권리를 존중받고 동등한
                  시민으로서 대우받아야 합니다.
                </li>
                <li>
                  모든 아동은 자신에게 영향을 주는 법률과 공공 정책, 예산,
                  프로그램에 대해 의견을 말하고 그 의견을 존중받아야 합니다.
                </li>
                <li>
                  모든 아동은 양질의 기본적 서비스를 누릴 권리가 있습니다.
                </li>
                <li>
                  모든 아동은 오염되지 않은 환경에서 안전하게 살 권리가
                  있습니다.
                </li>
                <li>
                  모든 아동은 가정생활에 참여하고 여가를 즐기며 놀 권리가
                  있습니다.
                </li>
              </NoList>
            </article>

            <article>
              <h3>
                <Tit size="s1">인증은 어떻게 이루어지나요?</Tit>
              </h3>

              <HowArticle>
                <dl className="dl-wrap">
                  <dt>
                    <Tit size="s2" color="sky">
                      인증심사 기준
                    </Tit>
                  </dt>
                  <dd>
                    <p className="dec">
                      아동친화도시는 5가지 평가영역과 6가지 아동친화영역을
                      기반으로 조성됩니다.
                    </p>
                    <AreaGroupTitle>
                      <Tit size="s4">5가지 평가영역</Tit>
                    </AreaGroupTitle>
                    <AreaList>
                      {assessmentData.map((row) => (
                        <li key={row.id}>
                          <div className="icon-wrap">
                            <Image pcSrc={row.img} mobileSrc={row.img} />
                          </div>
                          <div className="text-wrap">
                            <span className="area-no">{row.no}</span>
                            <Tit size="s4" className="area-title">
                              {row.tit}
                            </Tit>
                            <p className="area-desc">{row.desc}</p>
                          </div>
                        </li>
                      ))}
                    </AreaList>
                    <AreaGroupTitle>
                      <Tit size="s4">6가지 아동친화영역</Tit>
                    </AreaGroupTitle>
                    <AreaList>
                      {childFriendlyData.map((row) => (
                        <li key={row.id}>
                          <div className="icon-wrap">
                            <Image pcSrc={row.img} mobileSrc={row.img} />
                          </div>
                          <div className="text-wrap">
                            <span className="area-no">{row.no}</span>
                            <Tit size="s4" className="area-title">
                              {row.tit}
                            </Tit>
                            <p className="area-desc">{row.desc}</p>
                          </div>
                        </li>
                      ))}
                    </AreaList>
                  </dd>
                </dl>
                <dl className="dl-wrap">
                  <dt>
                    <Tit size="s2" color="sky">
                      인증절차
                    </Tit>
                  </dt>
                  <dd>
                    <CertifyFlow>
                      <p className="certify-header">
                        아동 참여 원칙
                        <br />
                        비차별 원칙
                      </p>
                      <div className="certify-rows">
                        {certifySteps.map((row, rowIdx) => (
                          <div className="certify-row" key={rowIdx}>
                            {row.map((step, stepIdx) => (
                              <React.Fragment key={stepIdx}>
                                {stepIdx > 0 && (
                                  <div className="certify-arrow">
                                    <img src={StepArrow} alt="" />
                                  </div>
                                )}
                                <div className="certify-step">
                                  <img src={step.img} alt={step.label} />
                                </div>
                              </React.Fragment>
                            ))}
                          </div>
                        ))}
                      </div>
                    </CertifyFlow>
                    <p className="dec">
                      아동친화도시 조성을 기획, 이행, 평가하는 모든 단계가 상호
                      유기적으로 연결되어 있습니다. 한차례 인증에 그치지 않고
                      지방자치단체의 지속적인 변화와 노력을 통해 지역사회
                      이해관계자의 역량을 강화하고 궁극적으로는 '아동권리가
                      온전히 실현되는 지역사회'를 조성합니다.
                    </p>

                    <DlBox>
                      <dt>
                        <Tit size="s3" color="sky">
                          아동친화도시 인증제 기준
                        </Tit>
                      </dt>
                      <dd>
                        <ul className="cnt-list">
                          <li>
                            1. 여러 성과 영역에 걸쳐{` `}
                            <strong>포괄적인 아동권리적 접근</strong>이 이루어질
                            수 있도록 아동을 위해 이루어 낸 변화를 보여주어야
                            합니다.
                          </li>
                          <li>
                            2. 아동 의회나 청소년 의회와 같은 제도적 참여기구를
                            통해 아동친화도시를 추진하는 모든 단계에서
                            지방자치단체의 의사결정에{` `}
                            <strong>아동이 적극적으로 참여</strong>
                            합니다.
                          </li>
                          <li>
                            3. 지방자치단체가 아동친화도시 사업을 비롯한 각종
                            정책과 제도적 조치를 통해{` `}
                            <strong>
                              아동과 청소년에 대한 차별을 철폐하기 위해 어떤
                              노력을
                            </strong>
                            {` `}
                            하고 있는지 보여주어야 합니다.
                          </li>
                        </ul>
                      </dd>
                    </DlBox>
                  </dd>
                </dl>
              </HowArticle>
            </article>
          </div>
        </Container>
      </SectionIntro>

      <SectionCouncil className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">
                유니세프아동친화도시 추진
                <br /> 지방정부협의회
              </Tit>
            </h2>
            <p className="header-dec">
              유니세프아동친화도시 추진 지방정부협의회는 유니세프한국위원회와
              국내 유니세프아동친화도시 추진을 위해 협력하는 협의체입니다.
              아동친화도시로 인증 받았거나 인증을 추진하는 지방자치단체가
              지속적으로 늘어나면서 지방자치단체 간 소통을 위해, 2015년 27개
              지방자치단체가 모여 「유니세프 아동친화도시 추진
              지방정부협의회」를 결성했습니다. 유니세프한국위원회와
              지방정부협의회는 아동권리 컨퍼런스와 세미나, 간담회 등을 공동
              개최해 아동권리 인식을 제고하고, 지방자치단체 간 아동친화도시 모범
              사례를 공유하고 배우는 소통의 장을 마련합니다.
            </p>
          </SectionHeader>

          <LinkSafe
            to="http://childfriendlycities.kr/"
            target="_blank"
            className="bn-wrap"
          >
            <div className="col-dec">
              <Tit size="s4-1" color="yellow">
                마이크로 사이트 바로가기
              </Tit>
              <Tit size="s1" color="white">
                유니세프아동친화도시{` `}
              </Tit>
            </div>
            <figure className="col-img">
              <Image pcSrc={Bn} mobileSrc={Bn} />
            </figure>
          </LinkSafe>
        </Container>
      </SectionCouncil>

      <SectionNews className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <div className="flex-middle">
              <h2>
                <Tit size="s1">최근 소식</Tit>
              </h2>
              <LinkSafe to="/what-we-do/news?category=A024" className="more">
                <span className="txt">더 보기</span>
              </LinkSafe>
            </div>
          </SectionHeader>
          {news.length > 0 && (
            <RelativeBoardCard
              newslist={news}
              isDate={false}
              isSwiper
              overflowHidden
            />
          )}
        </Container>
      </SectionNews>

      <Section className="by-sub-main-layout">
        <Container>
          <ContactUs itemData={contactData} />
        </Container>
      </Section>
    </LayoutWithTitle>
  );
};
export default ChildFriendlyCities;
